import { faJira } from "@awesome.me/kit-4c83d50d0d/icons/classic/brands";
import { EditorState, NodeSelection, Transaction } from "prosemirror-state";

import { showFeatureModal } from "~/billing";
import type { AttendeeAttrs } from "~/common/Attendees";
import displayPromptInstallingJira from "~/integrations/jira/PromptInstallingJira";
import { createWorkspaceToast } from "~/lib/guestUserUtils";
import { getContext } from "~/lib/prose/plugins/context";
import type { TypeAheadState } from "~/lib/prose/plugins/typeahead";
import { expandSelectionToBlocks } from "~/lib/prose/utils";

import { selectionToJiraText } from "../actionItemIntegration/utils";
import { IntegrationLink } from "./IntegrationLink";

export const jiraSlashCommand = {
	title: "Jira",
	content: "Import or create a Jira issue.",
	icon: faJira,
	// shortcut: `${CtrlOrCmd}+j`,
	replaceMatch: false,
	showInToolbar: true,
	command: (_state: EditorState, typeAheadState?: TypeAheadState) => {
		return (state: EditorState, dispatch: (tr: Transaction) => void): boolean => {
			const context = getContext(state);
			const { isAccountAdmin, userId } = context;
			const attendee: AttendeeAttrs | undefined = context?.participants?.find((u: AttendeeAttrs) => u.id === userId);
			if (attendee?.isGuest) {
				createWorkspaceToast({ closeOnClick: true, autoClose: 15000 });
				return false;
			}
			if (!context.billing?.hasAccessToJiraIntegration) {
				showFeatureModal("jira_integration");
				return false;
			}
			if (!context.jira) {
				displayPromptInstallingJira();
				return false;
			}

			const tr = state.tr;
			const startPos = tr.selection.from;
			const [start] = expandSelectionToBlocks(startPos, startPos, tr.doc);
			const nodeSelection = NodeSelection.create(tr.doc, start);

			let initialText: string = selectionToJiraText(nodeSelection);

			if (typeAheadState) {
				const { matchingSelection } = typeAheadState;
				if (matchingSelection) {
					const mappedSelection = matchingSelection.resolve(tr.doc);
					mappedSelection.replace(tr);
					const currentSel = state.tr.selection;
					let modifiedTr = tr.setSelection(currentSel.map(tr.doc, tr.mapping));
					const modifiedNodeSelection = NodeSelection.create(modifiedTr.doc, start);

					initialText = selectionToJiraText(modifiedNodeSelection);
				}
			}

			new IntegrationLink({ editorState: state, dispatch, selection: nodeSelection, initialText, isAccountAdmin });
			return false;
		};
	},
};
